// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1Caah","title":"AfterBackImages_title__16uGe","images":"AfterBackImages_images__3MyiW"};